import { ReactNode, useState } from 'react';

interface UseTablePaginationResult<T> {
	pageNumber: number;
	setPageNumber: React.Dispatch<React.SetStateAction<number>>;
	prevPage: () => void;
	nextPage: () => void;
	displayPosts: ReactNode[];
}

const useTablePagination = <T>(
	arr?: T[] | null | undefined,
	tableCells?: (item: T) => any,
	setFetching?: (fetching: boolean) => void
): UseTablePaginationResult<T> => {
	const [pageNumber, setPageNumber] = useState(1);

	let displayPosts: ReactNode[] = [];

	const nextPage = () => {
		setPageNumber((prev) => prev + 1);
		if (setFetching) setFetching(true);
	};

	const prevPage = () => {
		if (pageNumber > 1) {
			setPageNumber((prev) => prev - 1);
			if (setFetching) setFetching(true);
		}
	};

	if (arr && arr.length > 0 && tableCells) {
		displayPosts = arr.map((ele) => tableCells(ele));
	}

	return { pageNumber, setPageNumber, prevPage, nextPage, displayPosts };
};

export default useTablePagination;
